<section id="metodos-pago" class="mt-10">
	<div class="bg-[#4D4D4D] py-4">
		<div class="max-w-screen-xl px-3 mx-auto">
			<div class="flex items-center justify-center gap-6 box-metodos">
				<div>
					<p class="text-white font-ubuntu text-f16">Paga tus pasajes con:</p>
				</div>
				<div class="flex items-center gap-16 logos-metodos">
					<div><img width="110" src="/images/diners-2.png" /></div>
					<div><img src="/images/amercian.png" /></div>
					<div><img width="64" src="/images/mastercard-2.png" /></div>
					<div><img src="/images/visa.png" /></div>
					<div><img src="/images/yape.png" /></div>
					<div><img src="/images/plin.png" /></div>
				</div>
			</div>
		</div>
	</div>
</section>
